<template>
  <div class="page_bg">
    <div class="ship_bg">
      <div class="ship_contant ">
        <div class="ship_contant_no">货单号：{{ shiplistInfo.shoppinglistNo }}</div>
        <van-divider />
        <div class="ship_contant_info flex-r-sa-c">
          <div class="info_item">
            <div class="num">{{ shiplistInfo.totalPrice }}</div>
            <div class="msg">货单总额</div>
          </div>
          <div class="info_item">
            <div class="num">{{ total }}</div>
            <div class="msg">商品种类</div>
          </div>
        </div>
      </div>
      <div class="ship_contant " style="margin-top:0.21rem">
        <div class="ship_contant_pro">
          <MyscrollList ref="myList01" :loading="listLoading" :list="proList" :line="1" :line-type="1"
                        @myload="proload"
          >
            <template #default="slotProps">
              <div class="company_pro_list">
                <div class="flex-r-s-c">
                  <proCard06 :info="slotProps.item" />
                </div>
                <van-divider />
              </div>
            </template>
          </MyscrollList>
        </div>
      </div>
      <!-- 底部提交 -->
      <div class="ship_contant_sub flex-c-c-c">
        <!-- <van-submit-bar :price="price" button-text="货单下单" button-color="#0767AB" @submit="subconfirmCase" /> -->
        <van-button round type="info" style="width:8.61rem;font-size: 0.43rem;" color="#0767AB" @click="subconfirmCase">货单下单</van-button>
      </div>
      <!-- 特价货单 -->
      <van-dialog v-model="specialDialog" :show-confirm-button="false" class="ship_vip_dialog">
        <div class="vipDialog_box flex-c-c-c">
          <div class="ship_title">特价货单</div>
          <div class="ship_msg">采购下单不享受会员折扣权益</div>
          <div class="ship_msg" style="margin-bottom: 0.3rem;margin-top: 0.1rem;">采购下单不累计会员交易金额</div>
          <van-button type="primary" color="rgb(8, 104, 171)" round style="width: 4rem;" @click="specialDialog = false">知道了</van-button>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import './index.scss'
import proCard06 from '@/components/pro_card_06'
import MyscrollList from '@/components/MyscrollList'
import { apiWholesaleShopinglist_detail, apiWholesaleShopinglist_detailProductList } from '@/api/order'
export default {
  components: { MyscrollList, proCard06 },
  data() {
    return {
      // 货单信息
      shiplistInfo: {},
      price: null,
      // 商品列表
      proSearch: { page: 1, limit: 20, shopinglistId: '' },
      proList: [],
      total: null,
      listLoading: false,

      specialDialog: false
    }
  },
  created() {
    this.shopinglistId = this.$route.query.id
    this.proSearch.shopinglistId = this.$route.query.id
    this.getDetail()
    this.getProList()
  },
  methods: {
    // 获取详情
    getDetail() {
      apiWholesaleShopinglist_detail({ shopinglistId: this.shopinglistId }).then(res => {
        if (!res.data.isInvalid) {
          this.shiplistInfo = res.data
          this.price = parseInt(this.shiplistInfo.totalPrice.replace('.', ''))
          if (parseInt(res.data.type) === 2) { this.specialDialog = true }
        } else {
          this.$router.push('/order/shiplistNotWork')
        }
      })
    },
    // 获取商品
    getProList() {
      this.$toast.loading({ message: '加载中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      apiWholesaleShopinglist_detailProductList(this.proSearch).then(res => {
        this.$toast.clear()
        this.$refs.myList01.load_loading(false)
        this.proList = this.proList.concat(res.data.list)
        this.total = parseInt(res.data.total)
        if (parseInt(res.data.total) === 0) { this.$refs.myList01.load_empty('list', true) } else {
          if (res.data.list.length === 0) { this.$refs.myList01.load_finished(true) } // 数据全部加载完成
        }
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.proSearch.page = this.proSearch.page + 1
        this.getProList()
        // 加载状态结束
      }, 50)()
    },
    // 提交
    subconfirmCase() {
      this.$router.push(`/order/subOrder?type=5&shopinglistId=${this.shopinglistId}`)
    }
  }
}
</script>

<style>
.item-list {
  width: 100% !important;
}
.ship_vip_dialog {
  width: 8rem;
  height: 6.13rem;
  background: rgba(0, 0, 0, 0);
}
.vipDialog_box {
  width: 8rem;
  height: 6.13rem;
  background: url("https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/VIP/special_dialog.png");
  background-size: 100%;
}
.ship_vip_dialog_btn {
  position: absolute;
  bottom: 0.1rem;
}
.ship_title {
  font-weight: 700;
  font-size: 0.43rem;
  text-align: left;
  color: #333;
  margin-top: 2rem;
  margin-bottom: 0.2rem;
}
.ship_msg {
  font-weight: 400;
  font-size: 0.37rem;
  text-align: left;
  color: #999;

}
</style>
